import * as React from "react";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { TextField, Autocomplete, Button, Checkbox, CircularProgress } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useForm, Controller, FieldValues } from "react-hook-form";
import { FundModel } from "../../util/All_interfaces";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { ToastMessage } from "../../util/ToastMessage";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";
import { useDispatch } from "react-redux";
import { UserContext, updateUserContext } from "../../../redux/slices/userContextSlice";
import { getProfile } from "../../../services/userContext";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const FundDisplayEditForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const userId = params.userRoleId;

  const [loading, setLoading] = useState(false);
  const [pageType, setPageType] = useState<boolean>(false);

  const [postFormdata, setPostFormData] = useState<FundModel>({
    fundID: '',
    fundName: '',
    region: '',
    id: '',
    createdBy: '',
    created: '',
    lastModifiedBy: '',
    lastModified: ''
  });

  const [postFormdataError, setPostFormdataError] = useState<any>({
    fundID: false,
    fundName: false,
    region: false,
    id: false,
    createdBy: false,
    created: false,
    lastModifiedBy: false,
    lastModified: false
  });

  const [regionList, setRegionList] = useState([{ title: "US", id: 1 }, { title: "EMEA", id: 2 }, { title: "APAC", id: 3 }]);
  const [fetchedRegionList, setFetchedRegionList] = useState<any>([]);
  const [postDataMessage, setPostDataMessage] = useState<{ code: number, message: string, isError: boolean }>({ code: 0, message: "", isError: false });

  const currentUserData: CurrentUser = useAppSelector((state) => state.currentUser.data);
  const userContext: UserContext = useAppSelector((state) => state.UserContext.data);

  const { control, handleSubmit } = useForm({});

  const regionHandler = (regionData: any) => {
    switch (regionData) {
      case 'US;EMEA':
        setFetchedRegionList([{ title: "US", id: 1 },
        { title: "EMEA", id: 2 }]);
        break;
      case 'US;APAC':
        setFetchedRegionList([{ title: "US", id: 1 },
        { title: "APAC", id: 3 }]);
        break;
      case 'US;EMEA;APAC':
        setFetchedRegionList([{ title: "US", id: 1 },
        { title: "EMEA", id: 2 },
        { title: "APAC", id: 3 }]);
        break;
      case 'EMEA;APAC':
        setFetchedRegionList([
          { title: "EMEA", id: 2 },
          { title: "APAC", id: 3 }]);
        break;
      case 'US':
        setFetchedRegionList([{ title: "US", id: 1 }]);
        break;
      case 'EMEA':
        setFetchedRegionList([{ title: "EMEA", id: 2 }]);
        break;
      case 'APAC':
        setFetchedRegionList([{ title: "APAC", id: 3 }]);
        break;
      case '':
        setFetchedRegionList([]);
        break;
    }
  }

  const handleRegionChangeAndDateTime = (value: any) => {
    let today = new Date();
    let date = today.getDate() + "-" + today.getMonth() + 1 + "-" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var selectedRegions = '';
    if (value.length == 0) {
      selectedRegions = '';
      setFetchedRegionList([]);
    } else {
      var repeatedRegions = ''
      value.forEach((element: any, index: any) => {
        for (let i = index + 1; i < value.length; i++) {
          if (element.title === value[i].title)
            repeatedRegions = value[i].title;
        }
      });

      var filteredRegionValues = value.filter((elem: { title: string; }) => elem.title !== repeatedRegions);
      var tempRegions: any[] = [];
      filteredRegionValues.forEach((element: { title: any; }) => {
        tempRegions.push(element.title);
      });
      var sortedTempRegions = tempRegions.sort().reverse();
      var filteredSortedTempRegions = sortedTempRegions.filter((value, index) => sortedTempRegions.indexOf(value) === index)
      filteredSortedTempRegions.forEach((element: any) => {
        if (selectedRegions == '') {
          selectedRegions = element;
        } else {
          selectedRegions = selectedRegions + ";" + element;
        }
      });

    }

    if (selectedRegions != null)
      regionHandler(selectedRegions);
    else
      setFetchedRegionList([]);

    setPostFormData({
      ...postFormdata, region: selectedRegions,
      lastModified: date, lastModifiedBy: currentUserData.email
    });
  }

  const fetchData = async () => {
    await getApiCall(`${TaskmgmtServiceURL}/Funds/GetById/${params.fundID}`,
      ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
        console.log(data.result);
        var resultData = data.result;

        if (resultData.region != null || resultData.region == '')
          regionHandler(resultData.region);

        setPostFormData({
          ...postFormdata,
          region: (resultData.region == null ? '' : resultData.region),
          created: resultData.created,
          createdBy: resultData.createdBy,
          lastModified: resultData.lastModified,
          lastModifiedBy: resultData.lastModifiedBy,
          id: resultData.id,
          fundID: resultData.fundID,
          fundName: resultData.fundName
        });
        setLoading(false);
      });

  }


  const submitForm = async () => {

    setLoading(true);
    if (postFormdata.fundName.length === 0 ||
      postFormdata.fundID.length === 0 ||
      postFormdata.region.length === 0) {
      setLoading(false);
      setPostDataMessage({ code: 0, message: "Please correct the validation errors!", isError: true });

      setTimeout(() => {
        setPostDataMessage({ code: 0, message: "", isError: false });
      }
        , 1500);
    } else {
      await postApiCall(`${TaskmgmtServiceURL}/Funds/Update`, postFormdata, ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
        setLoading(false);

        if (data.result == true) {
          setPostDataMessage({ code: 0, message: "Fund already exists", isError: true });
        } else {
          setPostDataMessage({ code: 1, message: "Fund Edited Successfully", isError: false });
        }

        setTimeout(() => {
          navigate(`/funds/list/`)
        }
          , 3500);


      }).catch(e => {
        setPostDataMessage({ code: e.response.status, message: e.response.data.responseException.exceptionMessage, isError: e.response.data.isError });
        setLoading(false);
      });
    }
  }

  useEffect(() => {
    if (Object.keys(userContext).length == 0) {
      getProfile(true).then((data: any) => {
        dispatch(updateUserContext(data));
      });
    }
  }, []);

  useEffect(() => {
    setPageType(page == "view" ? true : false);
    setLoading(true);
    if (Object.keys(userContext).length != 0) {
      fetchData();
      var regionContext = userContext.region;
      if (regionContext != '') {
        if (regionContext == 'US;EMEA') {
          setRegionList(
            [{ title: "US", id: 1 },
            { title: "EMEA", id: 2 }])
        }
        else if (regionContext == 'US;APAC') {
          setRegionList(
            [{ title: "US", id: 1 },
            { title: "APAC", id: 2 }])
        }
        else if (regionContext == 'EMEA;APAC') {
          setRegionList(
            [{ title: "EMEA", id: 1 },
            { title: "APAC", id: 2 }])
        }
      }

    }

  }, [userContext]);


  return (
    <div className="form-wrap">
      <Box sx={{ width: "100%", typography: "body1" }}>
        {loading ? (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        ) : null}
        {postDataMessage.isError ?
          <ToastMessage message={postDataMessage.message} severity="error" />
          : null}
        {postDataMessage.code == 1 ?
          <ToastMessage message={postDataMessage.message} severity="success" />
          : null}
        <Grid container spacing={3}>
          {!pageType ? <Grid item xs={8} sm={8}>
            <TextField
              required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
              label="Id"
              variant="outlined"
              size="small"
              fullWidth
              inputProps={{
                readOnly: true
              }}
              className={!pageType ? "Autopopulatefield" : ''}
              value={postFormdata.id}

            />
          </Grid> : null}

          <Grid item xs={8} sm={8}>
            {pageType ? <TextField
              required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
              label="Fund Name"
              defaultValue=""
              variant="outlined"
              size="small"
              inputProps={{
                readOnly: true
              }}
              value={postFormdata.fundName}
              className="Autopopulatefield"
              fullWidth
            /> : <Controller
              name="FundName"
              control={control}
              render={({ field }) => (
                <TextField
                  required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  label="Fund Name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={postFormdata.fundName}
                  onChange={(event: any) => {
                    setPostFormData({ ...postFormdata, fundName: event.target.value });
                    setPostFormdataError({ ...postFormdataError, fundName: event.target.value.length == 0 });
                  }}
                  error={postFormdataError.fundName}
                />
              )}
            />}
          </Grid>

          <Grid item xs={8} sm={8}>
            {pageType ? <TextField
              required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
              label="Fund ID"
              variant="outlined"
              size="small"
              inputProps={{
                readOnly: true
              }}
              className="Autopopulatefield"
              value={postFormdata.fundID}
              fullWidth
            /> : <Controller
              name="fundID"
              control={control}
              render={({ field }) => (
                <TextField
                  required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  label="Fund ID"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={postFormdata.fundID}
                  onChange={(event: any) => {
                    setPostFormData({ ...postFormdata, fundID: event.target.value });
                    setPostFormdataError({ ...postFormdataError, fundID: event.target.value.length == 0 });
                  }}
                  error={postFormdataError.fundID}
                />
              )}
            />}
          </Grid>

          <Grid item xs={8} sm={8}>
            {pageType ? <TextField
              {...params}
              label="Region"
              style={{ width: "100%" }}
              size="small"
              required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
              value={postFormdata.region}
              className="Autopopulatefield"
            /> : <Controller
              name="Region"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  options={regionList}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.title}
                  onChange={(event, value) => {
                    handleRegionChangeAndDateTime(value);
                    setPostFormdataError({ ...postFormdataError, region: false || value.length == 0 });
                  }}
                  value={fetchedRegionList}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected || postFormdata.region.includes(option.title)}
                      />
                      {option.title}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.region}
                    />
                  )}
                />
              )}
            />}

          </Grid>

          <Grid item xs={12} sm={12}>


            <Grid item xs={12} sm={12}>
              {pageType ? <Button sx={{textTransform:"none"}} variant="contained" size="medium" color="success"
                onClick={() => { navigate(`/funds/edit/${params.fundID}`); setPageType(false); }}
              >
                Edit
              </Button> : <Button sx={{textTransform:"none"}} variant="contained" size="medium" color="success"
                onClick={() => {
                  submitForm();
                  setPostFormdataError({
                    ...postFormdataError,
                    fundName: postFormdata.fundName.length === 0,
                    investmentType: postFormdata.fundID.length === 0,
                    appraisalSchedule: postFormdata.region.length === 0
                  });
                }} >
                Submit
              </Button>}
              <Button sx={{textTransform:"none",ml: 2}}
                variant="outlined"
                size="medium"
                color="error"
                onClick={() => navigate("/funds/list")}
              >
                {pageType ? "Close" : "Cancel"}
              </Button>
            </Grid>

          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
